import React, { useState } from "react";
import TextBlock from "./TextBlock";
import EvidenceModeToggle from "../common/EvidenceModeToggle";
import EvidenceBrowser from "../evidence/EvidenceBrowser";
import EvidenceNetwork from "../graphlab/EvidenceNetwork";

/** Case-chapter block (element.evidence-explorer): the full evidence
 *  instrument — search browser and network view behind a local mode
 *  toggle — embedded in the case narrative. Breaks out of the page
 *  container to full viewport width so the radial gets the same stage as
 *  the standalone page. On small screens the toggle hides (shared CSS)
 *  and the responsive search browser stands alone. */

const styles = `
.evd-fullbleed { width: 100vw; max-width: 100vw;
  margin-left: calc(50% - 50vw); padding: 0 40px; box-sizing: border-box; }
@media (max-width: 768px) { .evd-fullbleed { padding: 0 16px; } }
`;

interface EvidenceExplorerBlockProps {
  heading?: string;
}

const EvidenceExplorerBlock = ({ heading }: EvidenceExplorerBlockProps) => {
  const [mode, setMode] = useState<"search" | "graph">("graph");
  // Both lenses stay mounted once visited (hidden, not unmounted), so
  // flipping Network ↔ Search never loses either side's state. The
  // search lens mounts lazily on its first visit.
  const [searchVisited, setSearchVisited] = useState(false);
  const selectMode = (next: "search" | "graph") => {
    if (next === "search") setSearchVisited(true);
    setMode(next);
  };

  return (
    <div id="evidence-explorer">
      <style>{styles}</style>
      {heading && <TextBlock caseTitle={heading} cssClass="mt--100" />}
      <div className="evd-fullbleed mt-xl-4">
        <EvidenceModeToggle mode={mode} onSelect={selectMode} />
        <div style={mode === "graph" ? undefined : { display: "none" }}>
          <EvidenceNetwork embedded preferSmallestSet
            onUseSearch={() => selectMode("search")} />
        </div>
        {(searchVisited || mode === "search") && (
          <div style={mode === "search" ? undefined : { display: "none" }}>
            <EvidenceBrowser embedded preferSmallestSet />
          </div>
        )}
      </div>
    </div>
  );
};

export default EvidenceExplorerBlock;
